<template>
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
        <el-card header="设置规则内容" shadow="naver">
            <el-form-item label="名称" prop="package_name" :rules="{required: true, message: '名称', trigger: 'blur'}">
                <el-col :span="20">
                    <el-input v-model="form.package_name" :maxlength=30 placeholder="最多30个字"></el-input>
                </el-col>
            </el-form-item>
          <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="分类" :rules="{required: true, message: '名称', trigger: 'blur'}">
                  <el-select v-model="form.brand_id" filterable placeholder="请选择">
                    <el-option
                      v-for="item in brandList"
                      :key="item.attribute_id"
                      :label="item.attribute_name"
                      :value="item.attribute_id">
                    </el-option>
                  </el-select>
                </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="20">
            <el-form-item label="用法用量" :rules="{required: true, message: '用法用量', trigger: 'blur'}">
              <el-input v-model="form.dosage" :maxlength="160" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="20" >
            <el-form-item label="功能主治" :rules="{required: true, message: '功能主治', trigger: 'blur'}">
              <el-input v-model="form.purpose" :maxlength="160" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-card>
        <el-card header="主商品">
          <el-form-item label="选择主商品">
            <el-col :span="20">
                <el-button type="primary" class="el-icon-plus" @click="relMainClick" size="mini" round>主商品选择
                </el-button>
                <GoodsSelect :items-visible="mainVisible" :get-status="setMainStatus" :single="singleData" :rel-items-ids="relMain"
                              :item-type="form.item_type" @chooseStore="chooseMainAction"
                              @closeStoreDialog="closeMainDialogAction"></GoodsSelect>
            </el-col>
            <el-table :data="relMain" style="line-height: normal">
                <el-table-column label="ID" prop="item_id" width="90"></el-table-column>
                <el-table-column label="名称" prop="item_name" min-width="90"></el-table-column>
                <el-table-column label="价格(元/g)" prop="price" width="90"></el-table-column>
                <el-table-column label="规格(克/g)" width="90">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.spec" width="90" size="mini"></el-input>
                        </template>
                </el-table-column>
            </el-table>
            </el-form-item>
        </el-card>
        <el-card header="次商品" shadow="naver">
            <SkuSelector @change="getItems" @newPrice="getNewPrice" :data="relItems" :limit="1" :hiddenData="relMain"></SkuSelector>
        </el-card>
        <el-card header="商品详情图">
        <el-col :xs="24">
                  <el-form-item label="*商品图">
                    <div>
                      <div class="pics-box">
                        <ul class="goodspic-wrap">
                          <draggable v-model="form.pics" :options="dragIssuesOptions" class="components-view">
                            <li v-for="(item, index) in form.pics" :key='index' class="goodspic" @mouseenter="picsEnter(index)" @mouseleave="picsLeave">
                              <img :src="wximageurl + item" />
                              <div class="goodspic-mask" :class="(picsCurrent == index) ? 'on' : ''">
                                <div class="iconfont icon-trash-alt" @click="removePicsImg(index)"></div>
                                <div class="iconfont icon-arrows-alt"></div>
                              </div>
                            </li>
                          </draggable>
                        </ul>
                        <div v-if="form.pics.length < 9" class="upload-box" @click="handlePicsChange">
                          <i class="iconfont icon-camera"></i>
                        </div>
                      </div>
                      <div class="frm-tips">
                        <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
                        <p>2. 拖动图片进行可排序</p>
                      </div>
                    </div>
                    <imgPicker :dialog-visible="picsDialog" :sc-status="isGetPics" :is-most="multiple" @chooseImg="pickPics" @closeImgDialog="closePicsDialog"></imgPicker>
                  </el-form-item>
            </el-col>
            </el-card>
            <el-card header="图文详情" shadow="never" v-loading="loader">
              <el-form-item label="模式">
                <el-radio-group v-model="mode">
                  <el-radio :label="'richText'">富文本</el-radio>
                  <el-radio :label="'component'">组件式</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="mode === 'richText'">
                <vue-html5-editor :content="form.intro" ref="editor" @change="updateContent" :height="360"></vue-html5-editor>
                <span class="tpl_item img" @click="addImgPreview" style="">
                  <i class="iconfont icon-image"></i>图片
                </span>
              </template>
              <template v-else>
                <richTextEditor :data="content" :control="['film','slider','heading','writing']" @change="handleContent"/>
              </template>
              <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
            </el-card>
        <div class="content-center">
            <el-button type="primary" v-if="hasSaveButton" @click="submitActivityAction()">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
        </div>
    </el-form>
</template>

<script>
  import GoodsSelect from '@/components/goodsSelect'
  import SkuSelector from '@/components/function/skuSelectorPrice'
  import {getGradeList} from '../../../../api/membercard'
  import {listVipGrade} from '../../../../api/cardticket'
  import imgPicker from '@/components/imageselect'
  import draggable from 'vuedraggable'
  import imgBox from '@/components/element/imgBox'
  import richTextEditor from '@/components/function/richTextEditor'
  import {createPackagePromotions, getPackagePromotionsInfo, updatePackagePromotions,getItemsDetail,getGoodsAttr} from '../../../../api/goods'

  export default {
    inject: ['refresh'],
    components: {
      SkuSelector,
      GoodsSelect,
      imgPicker,
      draggable,
      richTextEditor,
      imgBox
    },
    data() {
      return {
        relItems: [],
        relItemsTemp: [],
        validGrade: [],
        vipGrade: [],
        memberGrade: [],
        activity_date: '',
        brandList: [],
        mainCateLoader: false,
        form: {
          package_name: '',
          used_platform: 0,
          free_postage: 1,
          new_price: 0,
          price:0,
          items: [],
          main_item: {},
          valid_grade: [],
          dosage:'',
          brand_id: '',
          purpose:'',
          pics: [],
          intro: ''
        },
        loader: true,
        dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
        },
        relMain: [],
        setMainStatus: false,
        mainVisible: false,
        singleData: true,
        hasSaveButton: true,
        picsList: [],
        content: [],
        specImages: [],
        dialogVisible: false,
        dialogImageUrl: '',
        thumbDialog: false,
        isGetThumb: false,
        isGetPics: false,
        picsDialog: false,
        picsCurrent: -1,
        currentSku: -1,
        picsOldLen: 0,
        mode: 'richText',
        multiple: false,
      }
    },
    methods: {
      submitActivityAction() {
        const that = this
        if (this.activity_date.length > 0) {
          this.form.start_time = this.activity_date[0] / 1000
          this.form.end_time = this.activity_date[1] / 1000
        }

        if (this.validGrade.length > 0) {
          this.form.valid_grade = this.validGrade
        }

        if (this.mode === 'component') {
          this.form.intro = JSON.stringify(this.content)
        }

        if (this.relMain.length > 0) {
          this.form.main_item = {"item_id": this.relMain[0].item_id, "item_price": this.relMain[0].price,"spec": this.relMain[0].spec}
        }

        if (this.$route.params.id) {
          updatePackagePromotions(this.$route.params.id, this.form).then(response => {
            this.loading = false
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.refresh()
                that.$router.go(-1)
              }
            })
          }).catch()
        } else {
          createPackagePromotions(this.form).then(response => {
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.refresh()
                that.$router.go(-1)
              }
            })
          }).catch()
        }
      },
      getNewPrice(new_price) {
        this.form.new_price = new_price
      },
      getItems(data) {
        let items = []
        this.relItemsTemp = JSON.parse(JSON.stringify(data))
        data.forEach(item => {
          items.push({'item_id': item.itemId, 'new_price': item.new_price, 'price':item.price})
        })
        this.form.items = items
      },
      getListVipGrade() {
        listVipGrade().then(response => {
          if (response != undefined && response.data.data && response.data.data.length > 0) {
            this.vipGrade = response.data.data
          }
        })
      },
      getGradeList() {
        getGradeList().then(response => {
          if (response != undefined && response.data.data && response.data.data.length > 0) {
            var result = response.data.data
            if (result) {
              this.memberGrade = result
            }
          }
        })
      },
      pickPics (data) {
        if (this.currentSku === -1) {
          if (this.picsOldLen + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          }else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.pics.push(data.url)
                  this.picsOldLen = this.form.pics.length
                }
              })
            }
          }
        } else {
          if (this.specImages[this.currentSku].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages[this.currentSku].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku = -1
        }
        this.picsDialog = false
      },
      updateContent: function (data) {
        this.form.intro = data
      },
      handleCancel: function () {
        this.$router.go(-1)
      },
      handleContent (data) {
        this.content = data
      },
      pageChange(val) {
        this.currentPage = val
      },
      // 详情中的上传图片
      addImgPreview: function () {
        this.thumbDialog = true
        this.isGetThumb = true
      },
      pickThumb: function (arr) {
        if (arr.length != 0) {
          arr.forEach(data => {
            if (data && data.url !== '') {
              this.thumbDialog = false
              var index = this.$refs.editor.$el.id
              var loc = this.$refs.editor
              var img = new Image()
              img.src = this.wximageurl + data.url
              if (loc.range) {
                loc.range.insertNode(img)
                var referenceNode = loc.range.endContainer
                if (referenceNode.className !== 'content') {
                  loc.range.setStartAfter(referenceNode)
                } else {
                  loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                }
              } else {
                loc.$refs.content.appendChild(img)
                loc.focus()
                loc.restoreSelection()
              }
              this.form.intro = loc.$refs.content.innerHTML
            }
          })
        }
      },
      closeThumbDialog: function () {
        this.thumbDialog = false
      },
      closeImgDialog () {
        this.imgDialog = false
      },
      //上传商品图（9张）
      handlePicsChange: function () {
        this.picsDialog = true
        this.isGetPics = true
        this.multiple = true
      },
      closePicsDialog () {
        this.picsDialog = false
      },
      picsEnter (index) {
        this.picsCurrent  = index
      },
      picsLeave () {
        this.picsCurrent  = -1
      },
      removePicsImg: function (index) {
        this.form.pics.splice(index, 1)
        this.picsOldLen = this.form.pics.length
      },
      getPackagePromotionsInfo(id) {
        getPackagePromotionsInfo(id).then(response => {
          this.form.used_platform = response.data.data.used_platform
          this.form.free_postage = response.data.data.free_postage
          this.form.package_name = response.data.data.package_name
          this.form.validGrade = response.data.data.valid_grade
          this.form.dosage     = response.data.data.dosage
          this.form.purpose    = response.data.data.purpose
          this.form.brand_id    = response.data.data.brand_id+''
          response.data.data.itemTreeLists.forEach(item => {
            item.new_price = response.data.data.new_price[item.itemId]
          })
          this.relMain = JSON.parse(JSON.stringify(response.data.data.mainItem))
          this.relMain[0].price = response.data.data.mainItem[0].price / 100
          this.relMain[0].spec = response.data.data.spec
          this.relItems = response.data.data.itemTreeLists
          this.activity_date = [response.data.data.start_time * 1000, response.data.data.end_time * 1000]
          this.form.pics = response.data.data.pics
          this.form.intro = response.data.data.intro
          this.picsOldLen = this.form.pics.length
          this.loader = false
        })
      },
      closeMainDialogAction() {
        this.mainVisible = false
      },
      chooseMainAction(data) {
        console.log('11111',data)
        this.mainVisible = false
        this.relMain = JSON.parse(JSON.stringify(data))
        this.relMain[0].price = this.relMain[0].price/100
        let index = this.relItemsTemp.findIndex(n => n.itemId === this.relMain[0].itemId)
        this.relItemsTemp.splice(index, 1)
        this.relItems = JSON.parse(JSON.stringify(this.relItemsTemp))
      },
      relMainClick() {
        this.mainVisible = true
        this.setMainStatus = true
      },
      handleCancel() {
        this.$router.back(-1)
      },
      init () {
        getGoodsAttr({page: 1, pageSize: 500, attribute_type: 'category'}).then(res => {
          for (let item of res.data.data.list) {
            this.brandList.push({attribute_name: item.attribute_name, attribute_id: item.attribute_id})
          }
        })
      }
    },
    mounted() {
      if (this.$route.query.isshow) {
        this.hasSaveButton = false
      }
      this.getListVipGrade()
      this.getGradeList()
      this.init ()
      if (this.$route.params.id) {
        this.getPackagePromotionsInfo(this.$route.params.id)
      }else{
        this.loader = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// add.vue?efb08270